import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { DigestionDetails } from "./components/DigestionDetails";

export function DigestionPage() {
  return (
    <Page title="Digestion Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionDetails />
      </Container>
    </Page>
  );
}
